import { Point } from '../../_common/client/point';

class ViewportTransform {
    private static readonly MAX_ZOOM = 4;
    private static readonly MIN_ZOOM = 1;

    public zoom = 1;
    public translation: Point = Point.ORIGIN;

    public translateBy(delta: Point) {
        this.translation = this.translation.add(delta);
    }

    public zoomBy(factor: number, around = Point.ORIGIN) {
        const nextZoom = this.zoom * factor;
        if (nextZoom > ViewportTransform.MAX_ZOOM) {
            this.zoomBy(ViewportTransform.MAX_ZOOM / this.zoom, around);
            return;
        }
        if (nextZoom < ViewportTransform.MIN_ZOOM) {
            this.zoomBy(ViewportTransform.MIN_ZOOM / this.zoom, around);
            return;
        }
        this.zoom = nextZoom;
        this.translation = this.translation.add(around.subtract(this.translation).scale(1 - factor));
    }

    public reset() {
        this.zoom = 1;
        this.translation = Point.ORIGIN;
    }

    public createCSSTransform(): string {
        return `translate3d(${this.translation.x}px, ${this.translation.y}px, 0) scale(${this.zoom})`;
    }
}

export default ViewportTransform;
